import { render, staticRenderFns } from "./compayInfo.vue?vue&type=template&id=48f9193e&scoped=true"
import script from "./compayInfo.vue?vue&type=script&lang=js"
export * from "./compayInfo.vue?vue&type=script&lang=js"
import style0 from "./compayInfo.vue?vue&type=style&index=0&id=48f9193e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f9193e",
  null
  
)

export default component.exports